import axios from './index'
import url from './url'
// 引用fetch.js

function getInfotype (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/getInfotype`,
    { params: typeOne }
  )
}

function getShuxing (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/getShuxing`,
    { params: typeOne }
  )
}

function companyList (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/companyList`,
    typeOne
  )
}

function informationList (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/informationList`,
    typeOne
  )
}

function getMarketDetail (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/companyDetail`,
    { params: typeOne }
  )
}

function getMarketDetailRecommend (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/fujin`,
    { params: typeOne }
  )
}

function getMarketGoodsList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/goodsList`,
    { params: typeOne }
  )
}

function getNoticeList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/noticeList`,
    { params: typeOne }
  )
}

function getCompanyInfoList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/companyInfoList`,
    { params: typeOne }
  )
}

function liuyan (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/liuyan`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}

function guanzhu (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/guanzhu`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}

function browse (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/browse`,
    typeOne
  )
}

function like (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/market/like`,
    typeOne
  )
}

function footDaohang (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/footDaohang`,
    { params: typeOne }
  )
}

function countryRencaiList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/countryRencaiList`,
    { params: typeOne }
  )
}

function countryCompanyList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/countryCompanyList`,
    { params: typeOne }
  )
}

function storeCompanyList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/market/storeCompanyList`,
    { params: typeOne }
  )
}

function getLeibie (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getLeibie`,
    { params: typeOne }
  )
}

function getAppcode (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getAppcode`,
    { params: typeOne }
  )
}

function getConditions (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/checkSubaccountConditions`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function getSubaccountList (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getSubaccountList`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function getNextsubaccountConditions (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getNextsubaccountConditions`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function addSubaccount (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/addSubaccount`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}
function bindSubaccountPhonenumber (typeOne) {
  return axios.post(
    `${url.wz}/public/v1/bindSubaccountPhonenumber`,
    typeOne,
    {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }
  )
}
function cancelBindsubaccount (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/cancelBindsubaccount`,
    { 
      params: typeOne ,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    },
  )
}
function getHwtoken () {
  return axios.get(
    `${url.wz}/public/v1/getHwtoken`,
    {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      }
    }
  )
}
function getMeiZi (typeOne) {
  return axios.post(
   'https://vod.cn-north-4.myhuaweicloud.com/v1.0/611250865fc745efa7b9c6ed4ead8526/asset',
    typeOne,
    {
      headers: {
        'X-Auth-Token': localStorage.getItem('Token')
      }
    }
  )
}
function getShouQuan (typeOne) {
  return axios.get(
    'https://vod.cn-north-4.myhuaweicloud.com/v1.0/611250865fc745efa7b9c6ed4ead8526/asset/authority',
    {
      params: typeOne ,
      headers: {
        'X-Auth-Token': localStorage.getItem('Token'),
      }
    }
  )
}
function getuploaded (typeOne) {
  return axios.post(
    'https://vod.cn-north-4.myhuaweicloud.com/v1.0/611250865fc745efa7b9c6ed4ead8526/asset/status/uploaded',
    typeOne,
    {
      headers: {
        'X-Auth-Token': localStorage.getItem('Token'),
      }
    }
  )
}
function getDetails (typeOne) {
  return axios.get(
    'https://vod.cn-north-4.myhuaweicloud.com/v1.0/611250865fc745efa7b9c6ed4ead8526/asset/info',
    {
      params: typeOne,
      headers: {
        'X-Auth-Token': localStorage.getItem('Token'),
      }
    }
  )
}
var base64js_min = createCommonjsModule(function(e, t) {
  e.exports = function o(n, i, a) {
      function s(t, e) {
          if (!i[t]) {
              if (!n[t]) {
                  var r = "function" == typeof commonjsRequire && commonjsRequire;
                  if (!e && r)
                      return r(t, !0);
                  if (l)
                      return l(t, !0);
                  throw (e = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND",
                  e
              }
              r = i[t] = {
                  exports: {}
              },
              n[t][0].call(r.exports, function(e) {
                  return s(n[t][1][e] || e)
              }, r, r.exports, o, n, i, a)
          }
          return i[t].exports
      }
      for (var l = "function" == typeof commonjsRequire && commonjsRequire, e = 0; e < a.length; e++)
          s(a[e]);
      return s
  }({
      "/": [function(e, t, r) {
          r.byteLength = function(e) {
              var e = d(e)
              , t = e[0]
              , e = e[1];
              return 3 * (t + e) / 4 - e
          }
          ,
          r.toByteArray = function(e) {
              for (var t, r = d(e), o = r[0], r = r[1], n = new u(function(e, t) {
                  return 3 * (e + t) / 4 - t
              }(o, r)), i = 0, a = 0 < r ? o - 4 : o, s = 0; s < a; s += 4)
                  t = l[e.charCodeAt(s)] << 18 | l[e.charCodeAt(s + 1)] << 12 | l[e.charCodeAt(s + 2)] << 6 | l[e.charCodeAt(s + 3)],
                  n[i++] = t >> 16 & 255,
                  n[i++] = t >> 8 & 255,
                  n[i++] = 255 & t;
              2 === r && (t = l[e.charCodeAt(s)] << 2 | l[e.charCodeAt(s + 1)] >> 4,
              n[i++] = 255 & t);
              1 === r && (t = l[e.charCodeAt(s)] << 10 | l[e.charCodeAt(s + 1)] << 4 | l[e.charCodeAt(s + 2)] >> 2,
              n[i++] = t >> 8 & 255,
              n[i++] = 255 & t);
              return n
          }
          ,
          r.fromByteArray = function(e) {
              for (var t, r = e.length, o = r % 3, n = [], i = 0, a = r - o; i < a; i += 16383)
                  n.push(function(e, t, r) {
                      for (var o, n = [], i = t; i < r; i += 3)
                          o = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]),
                          n.push(function(e) {
                              return s[e >> 18 & 63] + s[e >> 12 & 63] + s[e >> 6 & 63] + s[63 & e]
                          }(o));
                      return n.join("")
                  }(e, i, a < i + 16383 ? a : i + 16383));
              1 == o ? (t = e[r - 1],
              n.push(s[t >> 2] + s[t << 4 & 63] + "==")) : 2 == o && (t = (e[r - 2] << 8) + e[r - 1],
              n.push(s[t >> 10] + s[t >> 4 & 63] + s[t << 2 & 63] + "="));
              return n.join("")
          }
          ;
          for (var s = [], l = [], u = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, i = o.length; n < i; ++n)
              s[n] = o[n],
              l[o.charCodeAt(n)] = n;
          function d(e) {
              var t = e.length;
              if (0 < t % 4)
                  throw new Error("Invalid string. Length must be a multiple of 4");
              e = e.indexOf("="),
              t = (e = -1 === e ? t : e) === t ? 0 : 4 - e % 4;
              return [e, t]
          }
          l["-".charCodeAt(0)] = 62,
          l["_".charCodeAt(0)] = 63
      }
      , {}]
  }, {}, [])("/")
})

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
      return typeof e
  }
  : function(e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
  }
  )(e)
}

function createCommonjsModule(e, t) {
  return e(t = {
    exports: {}
  }, t.exports),
  t.exports
}
export {
  getDetails,
  getuploaded,
  base64js_min,
  getShouQuan,
  getMeiZi,
  getHwtoken,
  cancelBindsubaccount,
  bindSubaccountPhonenumber,
  addSubaccount,
  getNextsubaccountConditions,
  getSubaccountList,
  getConditions,
  getInfotype,
  getShuxing,
  companyList,
  informationList,
  getMarketDetail,
  getMarketDetailRecommend,
  getMarketGoodsList,
  getNoticeList,
  getCompanyInfoList,
  liuyan,
  guanzhu,
  browse,
  like,
  footDaohang,
  countryRencaiList,
  countryCompanyList,
  storeCompanyList,
  getLeibie,
  getAppcode
}



// WEBPACK FOOTER //
// ./src/axios/market.js